import createHistory from 'history/createBrowserHistory';

export default createHistory({ basename: window._env_.production ? '/app/ui/' : '/' });
